
export default function SocialProof() {
  const testimonials = [
    {
      name: 'Carlos Eduardo Silva',
      role: 'Empresário',
      image: 'https://public.readdy.ai/ai/img_res/f01311f9dffe13aa95361be37fc7c4c8.jpg',
      text: 'Meu carro foi roubado e em menos de 2 horas a Rastrek já havia localizado e a polícia recuperou. Serviço impecável, recomendo demais!',
      rating: 5
    },
    {
      name: 'Mariana Costa',
      role: 'Advogada',
      image: 'https://readdy.ai/api/search-image?query=Professional%20Brazilian%20woman%20lawyer%20in%20her%2030s%20wearing%20elegant%20business%20attire%2C%20warm%20smile%2C%20modern%20office%20setting%2C%20natural%20lighting%2C%20high%20quality%20portrait%20photography%2C%20clean%20simple%20background&width=400&height=400&seq=client-rastrek-002&orientation=squarish',
      text: 'O aplicativo é muito fácil de usar e me dá total controle sobre meu veículo. A instalação foi rápida e o atendimento excelente.',
      rating: 5
    },
    {
      name: 'Roberto Almeida',
      role: 'Comerciante',
      image: 'https://readdy.ai/api/search-image?query=Professional%20Brazilian%20businessman%20in%20his%2050s%20wearing%20casual%20business%20shirt%2C%20friendly%20expression%2C%20modern%20commercial%20background%2C%20natural%20lighting%2C%20high%20quality%20portrait%20photography%2C%20clean%20simple%20background&width=400&height=400&seq=client-rastrek-003&orientation=squarish',
      text: 'Tenho 3 veículos com rastreador Rastrek. O custo-benefício é ótimo e a tranquilidade não tem preço. Melhor investimento que fiz!',
      rating: 5
    },
    {
      name: 'Juliana Ferreira',
      role: 'Médica',
      image: 'https://readdy.ai/api/search-image?query=Professional%20Brazilian%20female%20doctor%20in%20her%2030s%20wearing%20medical%20coat%2C%20confident%20smile%2C%20modern%20clinic%20background%2C%20natural%20lighting%2C%20high%20quality%20portrait%20photography%2C%20clean%20simple%20background&width=400&height=400&seq=client-rastrek-004&orientation=squarish',
      text: 'A cerca eletrônica me avisa sempre que meu carro sai da área permitida. Perfeito para quem tem filhos adolescentes aprendendo a dirigir.',
      rating: 5
    },
    {
      name: 'Fernando Santos',
      role: 'Engenheiro',
      image: 'https://readdy.ai/api/search-image?query=Professional%20Brazilian%20male%20engineer%20in%20his%2040s%20wearing%20polo%20shirt%2C%20confident%20expression%2C%20modern%20industrial%20background%2C%20natural%20lighting%2C%20high%20quality%20portrait%20photography%2C%20clean%20simple%20background&width=400&height=400&seq=client-rastrek-005&orientation=squarish',
      text: 'O monitoramento 24h me dá segurança total. Já precisei acionar o bloqueio de combustível e funcionou perfeitamente. Sistema top!',
      rating: 5
    },
    {
      name: 'Patricia Oliveira',
      role: 'Arquiteta',
      image: 'https://readdy.ai/api/search-image?query=Professional%20Brazilian%20female%20architect%20in%20her%2030s%20wearing%20modern%20business%20casual%20attire%2C%20warm%20smile%2C%20contemporary%20office%20background%2C%20natural%20lighting%2C%20high%20quality%20portrait%20photography%2C%20clean%20simple%20background&width=400&height=400&seq=client-rastrek-006&orientation=squarish',
      text: 'Instalação super rápida, em menos de 48h já estava tudo funcionando. O app é intuitivo e o suporte sempre disponível. Recomendo!',
      rating: 5
    }
  ];

  return (
    <section id="provas-sociais" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            O Que Nossos Clientes Dizem
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Milhares de clientes satisfeitos confiam na Rastrek para proteger seus veículos
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-gray-50 rounded-xl p-8 shadow-md hover:shadow-xl transition-all duration-300 border border-gray-200"
            >
              <div className="flex items-center gap-4 mb-6">
                <div className="w-16 h-16 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div>
                  <h4 className="font-bold text-gray-900 text-base">{testimonial.name}</h4>
                  <p className="text-gray-600 text-sm">{testimonial.role}</p>
                </div>
              </div>
              
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-500 text-lg"></i>
                ))}
              </div>
              
              <p className="text-gray-700 leading-relaxed text-sm italic">
                "{testimonial.text}"
              </p>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 max-w-5xl mx-auto">
          <div className="text-center">
            <div className="text-4xl md:text-5xl font-bold text-yellow-500 mb-2">15k+</div>
            <p className="text-gray-600 font-medium text-sm">Veículos Protegidos</p>
          </div>
          <div className="text-center">
            <div className="text-4xl md:text-5xl font-bold text-yellow-500 mb-2">98%</div>
            <p className="text-gray-600 font-medium text-sm">Taxa de Recuperação</p>
          </div>
          <div className="text-center">
            <div className="text-4xl md:text-5xl font-bold text-yellow-500 mb-2">24/7</div>
            <p className="text-gray-600 font-medium text-sm">Monitoramento</p>
          </div>
          <div className="text-center">
            <div className="text-4xl md:text-5xl font-bold text-yellow-500 mb-2">4.9</div>
            <p className="text-gray-600 font-medium text-sm">Avaliação Média</p>
          </div>
        </div>
      </div>
    </section>
  );
}
